module.exports = __webpack_public_path__ + "img/avatar-main.74a8ba9f.png";